import classNames from 'classnames';
import { Box, useScreenSize } from '@stitch-fix/mode-react';
import { CloudinaryImageFields } from '../CloudinaryImageWrapper';
import { MediaItem, MediaItemProps } from './MediaItem';
import styles from './styles.module.scss';
import { ContentItem, type ContentItemProps } from './ContentItem';
import { useStickyCtaContext } from '../StickyCta/useStickyCtaContext';
import { ModularComponentProps } from '../ModularPageWrapper/ModularPageWrapper';
import { useAutoAdvanceTimer } from './useAutoAdvanceTimer';
import { ContentStackJSONRichText } from '../../../scripts/schemaGenerator/fields/rte';
type GalleryHeroItem = {
  minorTitle: string;
  majorTitle: string;
  cta: {
    text: string;
    url: string;
  };
  media?: {
    mobile: CloudinaryImageFields;
    desktop: CloudinaryImageFields;
  };
  CtaButton?: React.ReactNode;
  subtitle?: ContentStackJSONRichText;
};
export type GalleryHeroProps = {
  items: GalleryHeroItem[];
  layout?: 'full' | 'split';
  buttonColor?: string;
  mediaTransition?: MediaItemProps['transition'];
  titleTransition?: ContentItemProps['titleTransition'];
  titleDisplay?: 'minor-major' | 'title-xlarge';
  contentBackgroundColor?: 'gray' | 'white' | 'none';
  mobileLayoutVariant?: 'contentFirst' | 'mediaFirst' | 'contentMediaStacked';
  mobileAlignContent?: 'left' | 'right' | 'bottom' | 'top' | 'center';
  alignContent?: 'left' | 'right' | 'bottom' | 'top' | 'center';
};
const getContentBackgroundColor = (color: string) => {
  switch (color) {
    case 'gray':
      return 'gray-99';
    case 'white':
      return 'white';
    default:
      return undefined;
  }
};
export const GalleryHero = ({
  layout = 'full',
  items,
  buttonColor,
  verticalSpacing,
  mediaTransition = 'zoom',
  titleTransition = 'slide-up',
  titleDisplay = 'minor-major',
  contentBackgroundColor = 'gray',
  mobileLayoutVariant = 'contentFirst',
  mobileAlignContent = 'bottom',
  alignContent = 'bottom'
}: GalleryHeroProps & ModularComponentProps) => {
  const {
    setStickyContainerTarget
  } = useStickyCtaContext();
  const {
    activeSlideIndex,
    shouldAnimate
  } = useAutoAdvanceTimer({
    totalItems: items.length
  });
  const screenSize = useScreenSize();
  const contentAlignment = screenSize === 'sm' || screenSize === 'md' ? mobileAlignContent : alignContent;
  return <Box bgColor="gray-99" mt={verticalSpacing}>
      <Box data-testid="gallery-hero-container" ref={setStickyContainerTarget} className={classNames(styles.container, styles[mobileLayoutVariant], styles[contentAlignment], {
      [styles.splitView]: layout === 'split'
    })}>
        <Box className={styles.media}>
          {items.map((item, index) => <MediaItem
        // eslint-disable-next-line react/no-array-index-key
        key={index} slideIndex={index} activeSlideIndex={activeSlideIndex} items={items} initialAnimate={shouldAnimate} transition={mediaTransition} />)}
        </Box>
        <Box className={styles.content} bgColor={getContentBackgroundColor(contentBackgroundColor)}>
          <ContentItem slideIndex={activeSlideIndex} items={items} buttonColor={buttonColor} titleTransition={titleTransition} titleDisplay={titleDisplay} />
        </Box>
      </Box>
    </Box>;
};